<p>{{ 'shared.toggle-icon-input.toggle-icon-input-works' | exp:'':'toggle-icon-input works!' }}</p>
